import { render, staticRenderFns } from "./passengersInfo.vue?vue&type=template&id=32b675a4"
import script from "./passengersInfo.vue?vue&type=script&lang=js"
export * from "./passengersInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports